import { useEffect, type ReactNode } from "react";
import { Box } from "@mui/joy";
import { recruitingBrandStyles } from "./recruitingBrand";
import type { PublicCampaignInfo } from "../../../types/hr";

export function PublicRecruitingBrand({
  campaign,
  children,
}: {
  campaign?: PublicCampaignInfo;
  children: ReactNode;
}) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = campaign
      ? `${campaign.role_title} · ${campaign.organization_name}`
      : "Job application";
    const existing = Array.from(
      document.querySelectorAll<HTMLLinkElement>('link[rel~="icon"]'),
    );
    const old = existing.map((link) => ({ link, href: link.href }));
    const brandIcon = campaign?.organization_logo;
    // Never retain an ApexOS favicon on the employer's public application.
    for (const link of existing) link.href = brandIcon || "data:,";
    return () => {
      document.title = previousTitle;
      for (const { link, href } of old) link.href = href;
    };
  }, [
    campaign?.organization_name,
    campaign?.role_title,
    campaign?.organization_logo,
  ]);
  return (
    <Box
      data-joy-color-scheme="light"
      data-testid="employer-brand"
      style={recruitingBrandStyles(campaign?.organization_brand_color)}
      sx={{
        minHeight: "100vh",
        bgcolor: "background.body",
        color: "text.primary",
        borderTop: "6px solid var(--joy-palette-primary-solidBg)",
      }}
    >
      {children}
    </Box>
  );
}
